import { swap } from "utils/object";

export const signageRationaleValues = {
  "Construction is complete": 1,
  "Signage is impractical for this project": 2,
  Other: 3,
};

export const signageRationaleTexts = swap(signageRationaleValues);
